import { isActiveFeature, isInactiveFeature, isVertex, noTarget } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'

const DirectSelectRouteModeCommon = {
  onVertex(state, e) {
    if (e.originalEvent.altKey) {
      const clickedPath = e.featureTarget.properties.coord_path
      if (!state.selectedCoordPaths.includes(clickedPath)) {
        state.selectedCoordPaths = [clickedPath]
      }
      this.onTrash(state)
      return
    }

    this.startDragging(state, e)
    const about = e.featureTarget.properties
    const selectedIndex = state.selectedCoordPaths.indexOf(about.coord_path)

    // Helper to parse path. Returns { prefix: string, index: number } or null
    const parsePath = path => {
      if (!path) return null
      const parts = path.split('.')
      const index = parseInt(parts[parts.length - 1], 10)
      if (isNaN(index)) return null
      const prefix = parts.slice(0, parts.length - 1).join('.')
      return { prefix, index }
    }

    if (e.originalEvent.shiftKey) {
      const lastSelectedPath = state.selectedCoordPaths[state.selectedCoordPaths.length - 1]
      const last = parsePath(lastSelectedPath)
      const current = parsePath(about.coord_path)

      if (selectedIndex === -1) {
        if (last && current && last.prefix === current.prefix) {
          let coordsLength = 0
          let isClosed = false
          if (this.getFeature) {
            const feature = this.getFeature(state.featureId)
            if (feature && feature.type === 'Polygon') {
              const ringIndex = current.prefix ? parseInt(current.prefix, 10) : 0
              const ring = feature.getCoordinates()[ringIndex]
              if (ring && ring.length > 0) {
                coordsLength = ring.length - 1
                isClosed = true
              }
            }
          }

          let start = last.index
          let end = current.index
          const prefix = last.prefix ? `${last.prefix}.` : ''

          let indicesToAdd = []

          if (isClosed && coordsLength > 0) {
            const directDist = Math.abs(end - start)
            const wrapDist = coordsLength - directDist
            if (wrapDist < directDist) {
              const minIdx = Math.min(start, end)
              const maxIdx = Math.max(start, end)
              for (let i = 0; i <= minIdx; i++) indicesToAdd.push(i)
              for (let i = maxIdx; i < coordsLength; i++) indicesToAdd.push(i)
            } else {
              const minIdx = Math.min(start, end)
              const maxIdx = Math.max(start, end)
              for (let i = minIdx; i <= maxIdx; i++) indicesToAdd.push(i)
            }
          } else {
            const minIdx = Math.min(start, end)
            const maxIdx = Math.max(start, end)
            for (let i = minIdx; i <= maxIdx; i++) indicesToAdd.push(i)
          }

          indicesToAdd.forEach(i => {
            const path = `${prefix}${i}`
            if (!state.selectedCoordPaths.includes(path)) {
              state.selectedCoordPaths.push(path)
            }
          })
        } else {
          state.selectedCoordPaths.push(about.coord_path)
        }
      } else {
        state.selectedCoordPaths.splice(selectedIndex, 1)
      }
    } else {
      // If not Shift, and not already selected, select only this one.
      if (selectedIndex === -1) {
        state.selectedCoordPaths = [about.coord_path]
      }
    }
    const selectedCoordinates = this.pathsToCoordinates(state.featureId, state.selectedCoordPaths)
    this.setSelectedCoordinates(selectedCoordinates)
  },

  onClick(state, e) {
    if (noTarget(e)) return this.clickNoTarget(state, e)
    if (isActiveFeature(e)) return this.clickActiveFeature(state, e)
    if (isInactiveFeature(e)) return this.clickInactive(state, e)

    this.stopDragging(state)
  },
}

export default DirectSelectRouteModeCommon
